module.exports = __webpack_public_path__ + "img/46-l.309aa04c.png";